class HeaderElement extends HTMLElement {
  constructor() {
    super();
    this.announcementKey = Theme.keys.announcement_key;
  }

  connectedCallback() {
    document.addEventListener("toggle-visibility:opened", (event) => {
      if (event.detail.target.closest("header-element")) {
        this.setAttribute("data-mobile-menu-is-open", "true");
      }
    });
    document.addEventListener("toggle-visibility:closed", (event) => {
      if (event.detail.target.closest("header-element")) {
        this.setAttribute("data-mobile-menu-is-open", "false");
      }
    });

    if (this.isAnnouncementClosed()) {
      return;
    }

    this.setAttribute("data-announcement-bar", "true");

    document.addEventListener("announcement-bar:closed", () => {
      this.setAttribute("data-announcement-bar", "false");
    });
  }

  disconnectedCallback() {
    document.removeEventListener("toggle-visibility:opened", (event) => {
      if (event.detail.target.closest("header-element")) {
        this.setAttribute("data-mobile-menu-is-open", "true");
      }
    });
    document.removeEventListener("toggle-visibility:closed", (event) => {
      if (event.detail.target.closest("header-element")) {
        this.setAttribute("data-mobile-menu-is-open", "false");
      }
    });

    document.removeEventListener("announcement-bar:closed", (event) => {
      if (event.detail.target.closest("header-element")) {
        this.setAttribute("data-mobile-menu-is-open", "false");
      }
    });
  }

  isAnnouncementClosed() {
    return localStorage.getItem(this.announcementKey) !== null;
  }
}

customElements.define("header-element", HeaderElement);
